module.exports = "/assets/data/82bb044565cfd31da8d4cd34150ccda1-DE6.data.json";